import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { Button, Navbar, Nav, NavItem } from "react-bootstrap";

const Header = ({ siteTitle }) => (
  <header className="header">
    <Navbar bg="dark" variant="dark" expand="lg">
    {/* // <Navbar bg="light" variant="light" expand="lg"> */}
      <Navbar.Brand as={Link} to="/">
        {siteTitle}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <NavItem>
            <Nav.Link as={Link} activeClassName="active" to="/about">
              概要
            </Nav.Link>
          </NavItem>
          <NavItem>
            <Nav.Link as={Link} activeClassName="active" to="/jigyo">
              内容
            </Nav.Link>
          </NavItem>
          <NavItem>
            <Nav.Link as={Link} activeClassName="active" to="/information">
              インフォメーション
            </Nav.Link>
          </NavItem>
          <NavItem>
            <Nav.Link as={Link} activeClassName="active" to="/contact">
              お問い合わせ
            </Nav.Link>
          </NavItem>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: '',
};

export default Header;
